<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">Kuwaiti Dinar</div>
                    <div data-width='15%' class="font light-gray">5,299</div>
                    <div data-width='15%' class="font">6,321</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">US Dollar</div>
                    <div data-width='15%' class="font light-gray">9,120</div>
                    <div data-width='15%' class="font">8,036</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Other currencies</div>
                    <div data-width='15%' class="font light-gray">691</div>
                    <div data-width='15%' class="font">543</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">15,110</div>
                    <div data-width='15%' class=" bold white">14,900</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">دينار كويتي</div>
                    <div data-width='15%' class="font light-gray">5,299</div>
                    <div data-width='15%' class="font">6,321</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">دولار أمريكي</div>
                    <div data-width='15%' class="font light-gray">9,120</div>
                    <div data-width='15%' class="font">8,036</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">عملات أخرى</div>
                    <div data-width='15%' class="font light-gray">691</div>
                    <div data-width='15%' class="font">543</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">15,110</div>
                    <div data-width='15%' class=" bold white">14,900</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>